import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { useQuery } from '@tanstack/react-query';
import { getInsightWidgetData } from '@terminal/services/insights/insights-service';

const QUERY_KEY_INSIGHT_WIDGET_DATA = 'QUERY_KEY_INSIGHT_WIDGET_DATA';

export const useGetInsightWidgetData = (insightId: string) =>
  useQuery({
    queryKey: [QUERY_KEY_INSIGHT_WIDGET_DATA, insightId],
    queryFn: () => getInsightWidgetData(insightId),
    enabled: !!insightId,
    staleTime: getTimeTillEndOfDayMs(),
  });
